/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedClassTypes200,
  GetApiV1ClassroomdisciplineSharedClassTypes401,
  GetApiV1ClassroomdisciplineSharedClassTypesQueryParams,
  GetApiV1ClassroomdisciplineSharedClassTypesQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassTypes.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedClassTypesQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassTypesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedClassTypes200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassTypes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedClassTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassTypes401>;

export const getApiV1ClassroomdisciplineSharedClassTypesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedClassTypes200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassTypesQueryResponse>;
